import { combineReducers } from 'redux';

import loadingArraySlice from 'modules/global/reducers/loadingArraySlice';

import * as types from '../../../actionTypes';

/**
 * @typedef {{
 *   delete: string[],
 *   duplicate: string[],
 * }} TagsDashboardLoadingReducer
 */

const selectId = payload => payload?.tagId ?? payload?.id ?? payload;

export default combineReducers({
  delete: loadingArraySlice(types.DELETE_TAG, {
    global: { selectId },
  }),
  duplicate: loadingArraySlice(types.CLONE_TAG, {
    global: { selectId },
  }),
});
